import { postWithAuth } from '@/lib/httpAdapter';
import apiUrl from './api';

export interface InvoiceData {
  id: string;
  number: string;
  status: string;
  amount_paid: number;
  amount_due: number;
  currency: string;
  created: number;
  period_start: number;
  period_end: number;
  invoice_pdf: string;
  hosted_invoice_url: string;
  subtotal: number;
  total: number;
  tax: number | null;
  description: string | null;
  paid: boolean;
  forgiven: boolean;
  attempt_count: number;
  attempted: boolean;
  due_date: number | null;
  receipt_number: string | null;
  statement_descriptor: string | null;
  subscription: string;
  charge: any; // This is an object, not a string
  payment_intent: any; // This is an object, not a string
  is_topup?: boolean; // Flag to identify topup invoices
}

export interface GetInvoicesResponse {
  Invoices: InvoiceData[];
  HasMore: boolean;
  Error: string;
}

export interface GetInvoicesRequest {
  OrganizationUUID: string;
  Limit: number;
  Offset?: number;
}

export const getInvoices = async (
  request: GetInvoicesRequest,
  user: any,
  organization: any
): Promise<GetInvoicesResponse> => {
  const response = await postWithAuth(`${apiUrl}billing/getInvoices`, request);

  if (!response.ok) {
    throw new Error(`Failed to fetch invoices: ${response.statusText}`);
  }

  return response.json();
};
